export const createRfpFields = [
  {
    field_type: 2,
    name: 'Budget 1',
    placeholder: 'Enter amount',
    mandatory: true,
    budget: true
  },

  {
    field_type: 2,
    name: 'Budget 2',
    placeholder: 'Enter amount',
    budget: true
  },

  {
    field_type: 2,
    name: 'Budget 3',
    placeholder: 'Enter amount',
    budget: true
  },

  {
    field_type: 7,
    name: 'Include flighting',
    mandatory: true,
    fieldItems: [
      {
        id: 'yes',
        value: 'yes',
        name: 'Yes'
      },
      {
        id: 'no',
        value: 'no',
        name: 'No'
      }
    ],
    budget: true
  },

  {
    field_type: 5,
    name: 'Campaign start date',
    mandatory: true,
    budget: true
  },

  {
    field_type: 5,
    name: 'Campaign end date',
    mandatory: true,
    budget: true
  },

  {
    field_type: 1,
    name: 'Provider',
    fielditems: [
      {
        name: 'Provider ABC',
        code: 'provider_abc'
      }
    ],
    budget: true
  },

  {
    field_type: 1,
    name: 'Financial supplier',
    fielditems: [
      {
        name: 'Supplier ABC',
        code: 'supplier_abc'
      }
    ],
    budget: true
  },

  {
    field_type: 1,
    name: 'Vendor id',
    fielditems: [
      {
        name: '22-M6RRUZL-1',
        code: '22-M6RRUZL-1'
      }
    ],
    mandatory: true,
    budget: true
  },

  {
    field_type: 1,
    name: 'Currency code',
    fielditems: [
      {
        name: 'USD',
        code: 'USD'
      }
    ],
    budget: true,
    mandatory: true,
  },

  {
    field_type: 1,
    name: 'Strategy',
    mandatory: true,
    fielditems: [
      {
        name: 'Awareness',
        code: 'Awareness'
      }
    ]
  },

  {
    field_type: 1,
    name: 'Media',
    mandatory: true,
    fielditems: [
      {
        name: 'Digital',
        code: 'digital'
      }
    ]
  },

  {
    field_type: 5,
    name: 'Due date',
    mandatory: true
  },

  {
    field_type: 11,
    name: 'Comments',
    mandatory: true,
    placeholder: 'Enter comments'
  },
  
  {
    field_type: 10,
    name: 'Attachments'
  }
];